/*
 * Sales-only instant task helpers: live-instant ordering and the pop-up's
 * short rule labels. The elapsed timer and expiry wording are shared with
 * other queues in util_components/instant_alert/instant_timer.
 */

import { is_terminal as isTerminal } from './overdue';

// The slice of a list row / relay item the instant helpers read.
export interface InstantItem {
  status?: string;
  is_instant?: boolean;
}

// An instant task still worth a timer: terminal work (submitted, auto-closed,
// auto-completed) is finished, so its urgency is history.
export const is_instant_live = (item: InstantItem | null | undefined): boolean =>
  !!item && !!item.is_instant && !isTerminal(item);

// The wireframe's pop-up wording for the instant rules it names; every other
// type keeps the server's rule label.
const SHORT_LABELS: Record<string, string> = {
  FRESH_LEAD: 'New Sign-up',
  NO_BOOK: 'No Booking',
  LOGIN_ISSUE: 'Login Issue',
  CHURNED_MEMBER_LOGIN: 'Churned Member',
  LEAD_OTP_NOT_VERIFIED: 'Unverified Lead',
  BOOKING_ERROR: 'Booking Error',
  SESSION_JOIN_CLOSE: 'Session Joining & Closing',
  PRE_SESSION_JOIN_CALL: '15-min Joining Call',
  BACKUP_SESSION_JOIN: 'Backup Session Join',
  TRIAL_PAYMENT_FAILED: 'Trial Payment Failure',
  NO_SHOW_CANCEL_CALL: 'No Show / Cancellation',
  REACTIVATION: 'Reactivation',
  CHURNED_MEMBER_BOOKED: 'Churned Member Booked',
  PAYMENT_DROP_OFF_POST_SESSION: 'Payment Drop-off'
};

export const short_label = (
  taskType: string | null | undefined,
  taskLabel?: string | null
): string => (taskType && SHORT_LABELS[taskType]) || taskLabel || taskType || '';
